import React, { useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepButton,
  Container,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Avatar,
  Chip,
  Paper,
  useTheme,
  Popover,
  IconButton,
  Tooltip,
  TableContainer,
} from "@mui/material";
import {
  AccessTime,
  School,
  Assignment,
  EmojiObjects,
  PlayCircle,
  Description,
  TipsAndUpdates,
  ContentCopy,
  Celebration,
  LocationOn,
  AssignmentTurnedIn,
  MenuBook,
  Inventory2,
  LocalDining,
} from "@mui/icons-material";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import imgCourtney from "../../assets/Images_GuestLecturers/courtney-luckhardt.jpg";
import imgElizabeth from "../../assets/Images_GuestLecturers/E_LaBeaud_headshot.jpg";
import imgErica from "../../assets/Images_GuestLecturers/Erica Kennedy.jpeg";
import imgJames from "../../assets/Images_GuestLecturers/J.Witkoski.jpg";
import imgJose from "../../assets/Images_GuestLecturers/jose-martinez-cruz.jpg";
import imgMunich from "../../assets/Images_GuestLecturers/Munich+HeadshotPNG.png";
import imgRoss from "../../assets/Images_GuestLecturers/Ross Walton.jpg";
import imgChloe from "../../assets/Images_GuestLecturers/Chloe Armstrong.jpg";
import imgWisnicki from "../../assets/Images_GuestLecturers/Wisnicki headshot.jpg";
import imgPhil from "../../assets/Images_HubStaff/Phill.png";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import imgMaeve from "../../assets/Images_HubStaff/maevelosen.jpg";
import imgJennifer from "../../assets/jennifer_brannock.png";
import imgEmma from "../../assets/emma_semrau.png";

const columnConfig = [
  { key: "time", label: "Time", icon: <AccessTime fontSize="small" /> },
  { key: "activity", label: "Activity", icon: <Assignment fontSize="small" /> },
  { key: "goals", label: "Goals", icon: <EmojiObjects fontSize="small" /> },
  {
    key: "takeaways",
    label: "Takeaways",
    icon: <TipsAndUpdates fontSize="small" />,
  },
  { key: "instructor", label: "Instructor", icon: <School fontSize="small" /> },
  {
    key: "procedure",
    label: "Procedure",
    icon: <PlayCircle fontSize="small" />,
  },
  {
    key: "tools",
    label: "Tools",
    icon: <PlayCircle fontSize="small" />,
  },

  {
    key: "location",
    label: "Location",
    icon: <LocationOn fontSize="small" />,
  },
  {
    key: "readings",
    label: "Readings",
    icon: <MenuBook fontSize="small" />,
  },
];

const scheduleData = {
  startDate: "2025-06-16",
  days: [
    {
      day: "Day 1",
      entries: [
        {
          time: "9:00 - 10:30 AM",
          activity: "Arrival/Move in",
          goals: "Hand out schedule",
          location: "McCartey Hall Entrance",
          readings: [
            {
              text: "The Archive after Theory (Ward and Wisnicki)",
              url: "https://dhdebates.gc.cuny.edu/read/untitled-f2acf72c-a469-49d8-be35-67f9ac1e3a60/section/a8eccb81-e950-4760-ba93-38e0b1f2b9d0#ch18",
            },
          ],
        },
        {
          time: "10:30 - 11:30 AM",
          activity: "Campus Tour and IDs",
          goals: "Print participant IDs, give campus tour",
          location: "",
          readings: [
            {
              text: "The Archive after Theory (Ward and Wisnicki)",
              url: "https://dhdebates.gc.cuny.edu/read/untitled-f2acf72c-a469-49d8-be35-67f9ac1e3a60/section/a8eccb81-e950-4760-ba93-38e0b1f2b9d0#ch18",
            },
          ],
        },
        {
          time: "11:30 - 12:30 PM",
          activity: "Early Lunch (Qdoba)",
          goals: "Participate in a meet and greet over lunch",
          location: "https://maps.app.goo.gl/eZrPudSs1hGZB8fv5",
          readings: [
            {
              text: "The Archive after Theory (Ward and Wisnicki)",
              url: "https://dhdebates.gc.cuny.edu/read/untitled-f2acf72c-a469-49d8-be35-67f9ac1e3a60/section/a8eccb81-e950-4760-ba93-38e0b1f2b9d0#ch18",
            },
          ],
        },
        {
          time: "12:45 - 1:30 PM",
          activity: "Basic Information",
          goals:
            "Basic information to know while on campus, giving out laptops, general orientation",
          location: "",
          readings: [
            {
              text: "The Archive after Theory (Ward and Wisnicki)",
              url: "https://dhdebates.gc.cuny.edu/read/untitled-f2acf72c-a469-49d8-be35-67f9ac1e3a60/section/a8eccb81-e950-4760-ba93-38e0b1f2b9d0#ch18",
            },
          ],
        },
        {
          time: "1:30 - 2:30 PM",
          activity: "Tech Setup",
          goals: "Meet with IT to get campus credentials set up",
          location: "",
          readings: [
            {
              text: "The Archive after Theory (Ward and Wisnicki)",
              url: "https://dhdebates.gc.cuny.edu/read/untitled-f2acf72c-a469-49d8-be35-67f9ac1e3a60/section/a8eccb81-e950-4760-ba93-38e0b1f2b9d0#ch18",
            },
          ],
        },
        {
          time: "2:30 - 3:30 PM",
          activity: "Opening Convocation",
          goals: "Adrian Wisnicki Convocational Pep Talk via Teams",
          location: "LAB 110",
          readings: [
            {
              text: "The Archive after Theory (Ward and Wisnicki)",
              url: "https://dhdebates.gc.cuny.edu/read/untitled-f2acf72c-a469-49d8-be35-67f9ac1e3a60/section/a8eccb81-e950-4760-ba93-38e0b1f2b9d0#ch18",
            },
          ],
        },

        {
          time: "5:30 PM",
          activity: "Recommended for Dinner: Oishi Hibachi and Sushi Bar",
          location: "https://maps.app.goo.gl/LZV24x3gaSHPePH79",
          readings: [
            {
              text: "The Archive after Theory (Ward and Wisnicki)",
              url: "https://dhdebates.gc.cuny.edu/read/untitled-f2acf72c-a469-49d8-be35-67f9ac1e3a60/section/a8eccb81-e950-4760-ba93-38e0b1f2b9d0#ch18",
            },
          ],
        },
      ],
    },
    {
      day: "Day 2",
      entries: [
        {
          time: "8:30 - 11:00 AM",
          activity: "DH Fundamentals and Beginning Digitization",
          goals: "Lectures in DigiLab on Digitization",
          takeaways: "Fundamentals of Digitization",
          instructor: {
            name: "Emma Semrau",
            avatar: imgEmma,
            email: "Emma.Semrau@usm.edu",
          },
          procedure:
            "Tour the facility on the second floor of McCain Library with the director of the DigiLab and learn about its uses",

          location: "McCain Library 210",
          readings: [
            {
              text: "Making it Matter (Boggs)",
              url: "https://dhdebates.gc.cuny.edu/read/untitled-aa1769f2-6c55-485a-81af-ea82cce86966/section/f29e68c9-e28e-4c1a-b083-93025a5ed6b3",
            },
          ],
        },

        { time: "11:00 -  12:30 PM", activity: "Break for Lunch" },
        {
          time: "12:30 - 3:30 PM",
          activity: "Practice with Digitization tools",
          goals: "Spend time in DigiLab",
          takeaways: "Tools and help are available",
          instructor: {
            name: "Emma Semrau",
            avatar: imgEmma,
            email: "Emma.Semrau@usm.edu",
          },
          procedure:
            "Experience digitization hands-on with tools and materials available in the USM DigiLab",

          location: "McCain Library 210",
          readings: [
            {
              text: "Minimal Computing (Risam, et al.)",
              url: "chrome-extension://efaidnbmnnnibpcajpcglclefindmkaj/https:/dhq-static.digitalhumanities.org/pdf/000646.pdf",
            },
          ],
        },

        {
          time: "5:30 PM",
          activity: "Visit Pocket Museum, Downtown ",
          location: "https://maps.app.goo.gl/PkPVfETPNyncohvC6",
        },
        {
          time: "6:00 PM",
          activity: "Dinner at Tabella Italian Restaurant",
          location: "https://maps.app.goo.gl/GX6dVffJa5bRDhwj9",
        },
      ],
    },
    {
      day: "Day 3",
      entries: [
        {
          time: "8:30 - 11:30 AM",
          activity: "Data Management",
          goals:
            "Treating data like a computer scientist, by making is as clear as possible",
          takeaways: "Best Data Hygiene Practices",
          instructor: {
            name: "Jose Martinez",
            avatar: imgJose,
            email: "Jose.Martinez@usm.edu",
          },
          procedure:
            "Jose will instruct us on the basics of `Data Hygiene` preparing data before project implementation, then will walk through some practicalities of hosting data online. Individual steps of procedure to be determined",
          tools: [
            { text: "Python", url: "https://www.python.org/downloads/" },
            { text: "Pandas", url: "https://pandas.pydata.org/" },
            { text: "Numpy", url: "https://numpy.org/" },
            { text: "Matplotlib", url: "https://matplotlib.org/ " },
          ],

          location: "LAB 110",
          readings: [
            {
              text: "Planning for Uncertainty: Building Trust in the Midst of Uncertainty in Digital Scholarship Projects (Champagne)",
              url: "chrome-extension://efaidnbmnnnibpcajpcglclefindmkaj/https:/dhq-static.digitalhumanities.org/pdf/000646.pdf",
            },
          ],
        },

        { time: "12:00 PM", activity: "Break for Lunch" },
        {
          time: "1:30 - 2:30 PM",
          activity: "Website Development",
          goals:
            "Tutorial on how to take data hygiene into account when building first website",
          takeaways: "How to use Squarespace",
          instructor: {
            name: "Jimmy Witkoski",
            avatar: imgJames,
            email: "James.Witkoski@usm.edu",
          },
          procedure:
            "Zoom tutorial on building a website with notes on how to avoid hangups",
          tools: [{ text: "Squarespace", url: "" }],

          location: "LAB 110",
          readings: [
            {
              text: "“Using Digital Humanities for Understanding COVID-19: Lessons from Digital History about earlier Coronavirus” (Jurić)",
              url: "https://www.medrxiv.org/content/10.1101/2022.02.02.22270333v1.full",
            },
          ],
        },
        {
          time: "2:30 - 3:30 PM",
          activity: "Physical Media before Digitization",
          goals:
            "Visit Library Archives to view Physical Objects for Digitization",
          takeaways: "All DH projects start out as physical media",
          instructor: {
            name: "Jennifer Brannock",
            avatar: imgJennifer,
            email: "Jennifer.Brannock@usm.edu",
          },
          procedure:
            "Visit Library Archives to connect physical materials to those digitized in Dropbox already",
          location: "Cook Library Archives",
          readings: [
            {
              text: "“Using Digital Humanities for Understanding COVID-19: Lessons from Digital History about earlier Coronavirus” (Jurić)",
              url: "https://www.medrxiv.org/content/10.1101/2022.02.02.22270333v1.full",
            },
          ],
        },
        {
          time: "5:30 PM",
          activity: "Recommended for Dinner: Jutamas Thai Restaurant",
          location: "https://maps.app.goo.gl/mFz7HmJPw5P4MxQD7",
        },
      ],
    },
    {
      day: "Day 4",
      entries: [
        {
          time: "8:30 - 11:30 AM",
          activity: "Tei Markup",
          goals:
            "Introduce XML, explain why we use it, discuss ways it can benefit our work/projects",
          takeaways: "Experience with XML encoding + a basic template document",
          instructor: {
            name: "Phill Howells",
            avatar: imgPhil,
            email: "phillip.howells@usm.edu",
          },
          procedure:
            "Tutorial walking through basic commands of Notepad++ as well as most common tags",
          tools: [{ text: "Notepad++", url: "https://notepad-plus-plus.org/" }],

          location: "LAB 110",
          readings: [
            {
              text: "“What is XML and why should humanists care? An even gentler introduction to XML” (Birnbaum)",
              url: "http://dh.obdurodon.org/what-is-xml.xhtml",
            },
          ],
        },

        { time: "12:00 PM", activity: "Break for Lunch" },
        {
          time: "1:30 - 2:30 PM",
          activity: "Omeka presentation",
          goals: "Establish that Omeka is a way to present metadata",
          takeaways:
            "Omeka is not a database in itself, but it can make a database look useful",
          instructor: {
            name: "Jennifer Brannock",
            avatar: imgJennifer,
            email: "Jennifer.Brannock@usm.edu",
          },
          procedure: "Tutorial on Dublin Core and use of Alt Text",
          tools: [
            {
              text: "Omeka free version",
              url: "https://omeka.org/s/download/",
            },
          ],

          location: "LAB 110",
        },
        {
          time: "2:30 - 3:30 PM",
          activity: "Writing around markup and databases",
          goals:
            "Thinking through the words that are needed to make digital presentations understandable",
          takeaways:
            "XML and Omeka show data, but it still needs to be interpreted",
          instructor: {
            name: "Phill Howells",
            avatar: imgPhil,
            email: "phillip.howells@usm.edu",
          },
          procedure:
            "Tweak the language used to populate pages on Squarespace and Omeka to tell a potential audience about why our materials (archives or your own) are important to them",

          location: "LAB 110",
          readings: [
            {
              text: "The question of questions: Am I ‘techie’ enough for (a) Digital Humanities (degree)? (LaTeX Ninja)",
              url: "https://latex-ninja.com/2020/12/27/the-question-of-questions-am-i-techie-enough-for-a-digital-humanities-degree/ ",
            },
          ],
        },
        {
          time: "5:30 PM",
          activity: "Dinner at Indian Delight (Provided)",
          location:
            "https://www.google.com/maps/place/Indian+Delight+Hattiesburg/@31.328058,-89.3785689,20z/data=!4m6!3m5!1s0x889cdf16c704a209:0x8092bf416d109e71!8m2!3d31.3280853!4d-89.3788244!16s%2Fg%2F11b5qr1lfn?entry=tts&g_ep=EgoyMDI1MDUyOC4wIPu8ASoASAFQAw%3D%3D&skid=eb545285-1dea-4d2c-bbc9-0ee7856788c0",
        },
      ],
    },
    {
      day: "Day 5",
      entries: [
        {
          time: "8:30 - 11:30 AM",
          activity: "GIS Mapping",
          goals: "Experience using GIS software",
          takeaways:
            "Knowing what GIS can provide a project with location data",
          instructor: {
            name: "Kayla Stan",
            avatar: imgMunich,
            email: "Kayla.Stan@usm.edu",
          },
          procedure: "Tutorial on GIS software",
          tools: [{ text: "QGIS", url: "" }],

          location: "LAB 110",
          readings: [
            {
              text: "What is Digital History? A Look at Some Exemplar Projects (Seefeldt) -",
              url: "https://digitalcommons.unl.edu/cgi/viewcontent.cgi?article=1097&context=historyfacpub ",
            },
          ],
        },

        { time: "12:00 PM", activity: "Break for Lunch" },
        {
          time: "1:30 - 3:30 PM",
          activity: "GIS Practice",
          goals: "Using GIS with data",
          takeaways:
            "Applying what we learned in the morning to data we can manipulate ourselves",
          instructor: {
            name: "Kayla Stan",
            avatar: imgMunich,
            email: "Kayla.Stan@usm.edu",
          },
          procedure: "Hands-on experience with GIS software",
          tools: "-",

          location: "LAB 110",
        },

        {
          time: "5:30 PM",
          activity: "Recommended for Dinner: Mahogany Bar",
          location:
            "https://www.google.com/maps/place/Mahogany+Bar/@31.3246162,-89.3488578,17z/data=!3m1!4b1!4m6!3m5!1s0x889cdeebe2fb60af:0x80966859ebc96d28!8m2!3d31.3246116!4d-89.3462829!16s%2Fg%2F1pv2p9nyn?entry=tts&g_ep=EgoyMDI1MDUyOC4wIPu8ASoASAFQAw%3D%3D&skid=4afeb5dc-077a-4efe-b1fa-cffd383d80d3",
        },
      ],
    },
    {
      day: "Day 6",
      entries: [
        {
          time: "12:00 - 1:30 PM",
          activity: "Go to African American Military History Museum",

          location: "https://maps.app.goo.gl/idG9MZscsdR6WgbC6",
        },

        {
          time: "5:30 PM",
          activity: "Recommended Dinner: Ed's Burger Joint",

          location: "https://maps.app.goo.gl/9cmRUQBffMCrc5Jx8",
        },
      ],
    },
    {
      day: "Day 7",
      entries: [
        {
          time: "2:00 PM",
          activity: "USM Play: The Mousetrap",

          location: "https://maps.app.goo.gl/rmZijjzU9fpFDnUz6",
        },

        {
          time: "5:30 PM",
          activity: "Recommended Dinner: Fuzzy's Tacos",

          location: "https://maps.app.goo.gl/bPTykA6BuaficKPK8",
        },
      ],
    },
    {
      day: "Day 8",
      entries: [
        {
          time: "8:30 - 11:30 AM",
          activity: "Ethical Data Visualizations",
          goals: "Learn about the ethics of presenting data visually",
          takeaways:
            "Some best practices in presenting data visually + examples of what not to do",
          instructor: {
            name: "Kayla Stan",
            avatar: imgMunich,
            email: "Kayla.Stan@usm.edu",
          },
          procedure:
            "Presentation on importance of ethics in data visualization",

          location: "LAB 110",
          readings: [
            {
              text: "Ethics and ethical data visualization: A complete guide (Cipan)",
              url: "https://viborc.com/ethics-and-ethical-data-visualization-a-complete-guide/#:~:text=The%20main%20ethical%20considerations%20during,accurately%20show%20the%20underlying%20data.",
            },
          ],
        },

        { time: "12:00 PM", activity: "Break for Lunch" },
        {
          time: "1:30 - 3:30 PM",
          activity: "Discussing AI and data visualization + ethics writ broad",
          goals: "Discuss AI and relevance to clarity in presentations",
          takeaways:
            "Best practices for when using AI to streamline data vis process",
          instructor: {
            name: "Kayla Stan",
            avatar: imgMunich,
            email: "Kayla.Stan@usm.edu",
          },
          procedure:
            "Practice with AI in creating data visualizations + conversation about why AI must be combined with attention to people affected by data",

          location: "LAB 110",
          readings: [
            {
              text: "“Relation-Oriented AI: Why Indigenous Protocols Matter for the Digital Humanities” (Brown, et al.) ",
              url: "https://dhdebates.gc.cuny.edu/read/debates-in-the-digital-humanities-2023/section/98dc1c8f-8583-4428-ac84-17ff072bdcad#ch04 ",
            },
          ],
        },

        {
          time: "5:30 PM",
          activity: "Optional walk on the Trace",
          location: "https://maps.app.goo.gl/y65K1AodG236YSWt7",
        },
        {
          time: "6:00 PM",
          activity: "Dinner at Glory Bound Gyro Co. (Provided)",
          location: "https://maps.app.goo.gl/HSTqA77rNn2dcMue9",
        },
      ],
    },
    {
      day: "Day 9",
      entries: [
        {
          time: "8:30 - 11:30 AM",
          activity: "Audio techniques for hosting podcasts online",
          goals:
            "History of Audio Tech + Preserving Audio + Techniques for Capturing Audio",
          takeaways: "Experience using audio tech",
          instructor: {
            name: "Ross Walton",
            avatar: imgRoss,
            email: "arthur.walton@usm.edu",
          },
          procedure: "Presentation on production and archival of audio files",
          tools: [
            { text: "Microphone ", url: "" },
            { text: "Audacity", url: "https://www.audacityteam.org/" },
          ],

          location: "LAB 110",
          readings: [
            {
              text: "How to Teach DH without Separating New from Old (Liming) ",
              url: "https://dhdebates.gc.cuny.edu/read/what-we-teach-when-we-teach-dh/section/11162808-26fc-4d83-8995-2e1240963aea",
            },
          ],
        },

        { time: "12:00 PM", activity: "Break for Lunch" },
        {
          time: "1:30 - 3:30 PM",
          activity:
            "Video techniques for capturing interviews and presenting stories",
          goals: "Explore videos and how to handle the files correctly",
          takeaways: "Examples of standards and how to be creative with them",
          instructor: {
            name: "Chloe Armstrong",
            avatar: imgChloe,
            email: "Chloe.Armstrong@usm.edu",
          },
          procedure:
            "Tutorial regarding standards of most interview recordings, leading into explanation of how not to be cliché, and finally hands-on camera time",
          tools: [{ text: "Nikon Camera", url: "" }],

          location: "LAB 110",
          readings: [
            {
              text: "Born-Pedagogical DH Learning While Teaching (McGinn and Coats) ",
              url: "https://dhdebates.gc.cuny.edu/read/what-we-teach-when-we-teach-dh/section/cf1ea393-3133-4f7e-a588-87d8c9e53ab8#ch01 ",
            },
          ],
        },

        {
          time: "5:30 PM",
          activity: "Dinner at Pyro's Fire Fresh Pizza",
          location: "https://maps.app.goo.gl/qnP51t7dc8zmW1k6A",
        },
      ],
    },
    {
      day: "Day 10",
      entries: [
        {
          time: "8:30 - 10:30 AM",
          activity: "Multimodal tools",
          goals: "Photogrammetry",
          takeaways: "How to create a 3D scan",
          instructor: [
            {
              name: "Courtney Luckhardt",
              avatar: imgCourtney,
              email: "Courtney.Luckhardt@usm.edu",
            },
          ],
          procedure:
            "Tutorials on some trendy DH tools to show how tech provides different approaches to presentation",
          tools: [
            { text: "Revopoint POP3 Plus Handheld 3D Scanner", url: "" },
            { text: "Polycam", url: "https://poly.cam/" },
          ],

          location: "LAB 110",
          readings: [
            {
              text: "Literature Is not Data: Against Digital Humanities (Marche) ",
              url: "https://lareviewofbooks.org/article/literature-is-not-data-against-digital-humanities/ ",
            },
          ],
        },
        {
          time: "10:30 - 11:30 AM",
          activity: "Multimodal tools",
          goals: "3D Printing",
          takeaways: "How to use a 3D printer",
          instructor: [
            {
              name: "Maeve Losen",
              avatar: imgMaeve,
              email: "maeve.losen@usm.edu",
            },
          ],
          procedure:
            "Tutorials on some trendy DH tools to show how tech provides different approaches to presentation",
          tools: [{ text: "Prusa MK4 3D Printer", url: "" }],
          location: "LAB 110",
          readings: [
            {
              text: "Literature Is not Data: Against Digital Humanities (Marche) ",
              url: "https://lareviewofbooks.org/article/literature-is-not-data-against-digital-humanities/ ",
            },
          ],
        },

        { time: "12:00 PM", activity: "Break for Lunch" },
        {
          time: "1:30 - 3:30 PM",
          activity: "DH Pedagogy or Presentation",
          goals: "Using interactive presentation formats",
          takeaways: "How to prioritize the Human among the Digital",
          instructor: {
            name: "Phill Howells",
            avatar: imgPhil,
            email: "phillip.howells@usm.edu",
          },
          procedure:
            "Presentation on best practices for presenting a DH project to an uninformed audience",

          location: "LAB 110",
          tools: "-",
          readings: [
            {
              text: "The Resistance to Digital Humanities (Greetham) ",
              url: "https://dhdebates.gc.cuny.edu/read/untitled-88c11800-9446-469b-a3be-3fdb36bfbd1e/section/4110ccc9-920a-47a2-80eb-77a43f3d6e86  ",
            },
          ],
        },

        {
          time: "5:30 PM",
          activity: "Dinner at Petra Café Greek & Mediterranian (Provided)",
          location: "https://maps.app.goo.gl/1Wsk2xmo3zZdEmLp6",
        },
      ],
    },
    {
      day: "Day 11",
      entries: [
        {
          time: "8:30 - 11:30 AM",
          activity: "Grant Writing resource allocation",
          goals: "Learn the ins and outs of applying for grant money",
          takeaways: "6 Critical Questions to ask before applying",
          instructor: {
            name: "Erica Kennedy",
            avatar: imgErica,
            email: "erica.kennedy@usm.edu ",
          },
          procedure: "Power Point Presentation",

          location: "LAB 110",
          readings: [
            {
              text: "Teaching the Politics and Practice of Textual Recovery with DIY Critical Editions (Woidat)",
              url: " https://searchworks.stanford.edu/view/12829441 ",
            },
          ],
        },

        { time: "12:00 PM", activity: "Break for Lunch" },
        {
          time: "1:30 - 3:30 PM",
          activity: "Developing a personalized approach",
          goals:
            "Learn what grants might be available to you and how to approach them",
          takeaways: "Practice formulating proposal language",
          instructor: {
            name: "Erica Kennedy",
            avatar: imgErica,
            email: "erica.kennedy@usm.edu ",
          },
          procedure: "Power Point Presentation",
          location: "LAB 110",
          readings: [
            {
              text: "The Function of Digital Humanities Centers at the Present Time (Fraistat) -",
              url: "https://dhdebates.gc.cuny.edu/read/untitled-88c11800-9446-469b-a3be-3fdb36bfbd1e/section/0543b679-092a-499a-be5d-42ef78059308",
            },
          ],
        },

        {
          time: "5:30 PM",
          activity: "Dinner at Phở Saigon Vietnamese Cuisine",
          location: "https://maps.app.goo.gl/zpVsVn9So3GWHU6YA",
        },
      ],
    },
    {
      day: "Day 12",
      entries: [
        {
          time: "8:30 - 10:30 AM",
          activity: "Practice Project Takeaway",
          goals: "Presentations on possible uses of archival materials",
          takeaways: "Ideas for projects going forward",
          procedure:
            "8 minute project presentations on skills and ideas learned and formulated during the workshop",

          location: "LAB 110",
        },
        {
          time: "10:30 - 11:30 AM",
          activity: "Program evaluation and Laptop turn in",
          goals:
            "Provide feedback for Hub to improve content, turn in laptop and any other lended materials",
          takeaways: "",
          procedure:
            "Time to fill out an evaluation form which will help the course organizers to improve the curriculum for next year",
        },

        {
          time: "12:00 PM",
          activity: "Final Lunch : Meet at Keg & Barrel",
          location: "https://maps.app.goo.gl/WShgaCnxRf1b8e7e8",
        },
        {
          time: "2:00 - 4:00 PM",
          activity: "Check out",
        },
      ],
    },
  ],
};
const dittoMark = "〃";
const ScheduleSummer2025 = () => {
  const tableRef = React.useRef(null);

  const theme = useTheme();
  const getWeekdaysFromStart = (start, count) => {
    const dates = [];
    let date = dayjs(start);
    while (dates.length < count) {
      const day = date.day();
      if (day !== 0 && day !== 6) {
        dates.push(date);
      }
      date = date.add(1, "day");
    }
    return dates;
  };
  const getDatesFromStart = (start, count) => {
    return Array.from({ length: count }, (_, i) => dayjs(start).add(i, "day"));
  };

  const totalDays = scheduleData.days.length;
  const weekdays = getDatesFromStart(scheduleData.startDate, totalDays);
  const today = dayjs();
  const currentDayIndex = Math.max(
    weekdays.findIndex((d) => !d.isAfter(today)),
    0
  );

  const [activeStep, setActiveStep] = useState(currentDayIndex);
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverData, setPopoverData] = useState(null);
  const isPopoverOpen = Boolean(anchorEl);
  const handleStepClick = (index) => {
    setActiveStep(index);
    setTimeout(() => {
      tableRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  const activeDaySchedule = scheduleData.days[activeStep] || {
    day: `Day ${activeStep + 1}`,
    entries: [],
  };

  const visibleColumns = columnConfig.filter((col) =>
    activeDaySchedule.entries.some((entry) => entry[col.key])
  );
  const activityStartIndex = visibleColumns.findIndex(
    (col) => col.key === "activity"
  );
  const activityColSpan = visibleColumns.length - activityStartIndex;

  const handlePopoverOpen = (event, data) => {
    setAnchorEl(event.currentTarget);
    setPopoverData(data);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverData(null);
  };

  const getMergedValue = (key, index) => {
    if (index === 0) return true;
    return (
      activeDaySchedule.entries[index][key] !==
      activeDaySchedule.entries[index - 1][key]
    );
  };
  const isSameAsPrev = (key, idx) => {
    const current = activeDaySchedule.entries[idx][key];
    const prev = activeDaySchedule.entries[idx - 1]?.[key];

    if (Array.isArray(current) && Array.isArray(prev)) {
      return (
        current.length === prev.length &&
        current.every(
          (val, i) => JSON.stringify(val) === JSON.stringify(prev[i])
        )
      );
    }

    return JSON.stringify(current) === JSON.stringify(prev);
  };
  const getRowSpanMap = (entries, key) => {
    const map = {};
    let i = 0;

    while (i < entries.length) {
      let count = 1;
      while (
        i + count < entries.length &&
        JSON.stringify(entries[i][key]) ===
          JSON.stringify(entries[i + count][key])
      ) {
        count++;
      }
      map[i] = count;
      i += count;
    }

    return map;
  };

  const rowSpanMaps = {};
  visibleColumns.forEach((col) => {
    rowSpanMaps[col.key] = getRowSpanMap(activeDaySchedule.entries, col.key);
  });

  return (
    <Box sx={{ background: "#f4f6f9", py: { xs: 4, md: 6 } }}>
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        <Typography
          variant="h5"
          align="center"
          fontWeight={500}
          gutterBottom
          sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
        >
          10-Day Schedule
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",

            mb: 4,
            px: { xs: 1, sm: 2 },
          }}
        >
          <Stepper
            nonLinear
            activeStep={activeStep}
            alternativeLabel
            sx={{
              width: "100%",
              flexWrap: "wrap",
              alignItems: "center",
              flexDirection: { xs: "column", sm: "row" },
              overflowX: { xs: "auto", sm: "visible" },
              "& .MuiStep-root": {
                minWidth: "80px",
                flex: "1 0 auto",
                px: { xs: 1, sm: 2 },
              },
              "& .MuiStepLabel-label": {
                fontSize: { xs: "0.75rem", sm: "1rem" },
                whiteSpace: "normal",
                textAlign: "center",
              },
              "& .MuiStepConnector-root": {
                display: { xs: "none", sm: "block" },
              },
            }}
          >
            {Array.from({ length: totalDays }).map((_, index) => (
              <Step key={index}>
                <StepButton onClick={() => handleStepClick(index)}>
                  <StepLabel>{weekdays[index].format("MMM D")}</StepLabel>
                </StepButton>
              </Step>
            ))}
          </Stepper>
        </Box>

        <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>
          {activeDaySchedule.day}
        </Typography>

        <Paper
          elevation={3}
          sx={{
            overflow: "auto",
            border: "1px solid #ccc",
            borderRadius: 2,
            maxWidth: "100%",
            position: "relative",
            maxHeight: "70vh",
          }}
          ref={tableRef}
        >
          <Table
            sx={{
              borderCollapse: "collapse",
              tableLayout: "fixed",
              width: "100%",

              minWidth: 800,
              width: "max-content",
              tableLayout: "auto",
              "& td, & th": {
                borderBottom: "1px solid #e0e0e0",
                padding: { xs: "8px", sm: "12px" },
                textAlign: "center",
                verticalAlign: "middle",
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
              },
              "& thead th": {
                borderBottom: "2px solid #ccc",
                backgroundColor: "#f8f8f8",
                fontWeight: 600,
                fontSize: { xs: "0.8rem", sm: "0.95rem" },
                whiteSpace: "nowrap",
              },
              "& tbody tr:nth-of-type(odd)": {
                backgroundColor: "#fafafa",
              },
              "& tbody tr:hover": {
                backgroundColor: "#f1f1f1", // subtle hover effect
              },
              "& tbody tr:last-child td": {
                borderBottom: "none", // remove bottom line from last row
              },
            }}
          >
            <TableHead>
              <TableRow sx={{ backgroundColor: theme.palette.grey[200] }}>
                {visibleColumns.map((col, colIdx) => {
                  const isFirstColumn = col.key === "time";
                  return (
                    <TableCell
                      key={col.key}
                      align="center"
                      sx={{
                        position: "sticky",
                        top: 0,
                        left: isFirstColumn ? 0 : undefined,
                        zIndex: isFirstColumn ? 3 : 2,
                        backgroundColor: "#f8f8f8",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        minWidth: isFirstColumn ? "120px" : "auto",
                        boxShadow: isFirstColumn
                          ? "2px 0 5px -2px rgba(0,0,0,0.1)"
                          : undefined,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 1,
                          flexDirection: { xs: "column", sm: "row" },
                        }}
                      >
                        {col.icon}
                        {col.label}
                      </Box>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {activeDaySchedule.entries.map((entry, idx) => {
                if (
                  entry.time === "5:00 PM" ||
                  entry.time === "5:30 PM" ||
                  entry.time === "6:00 PM"
                ) {
                  const timeCol = visibleColumns.find(
                    (col) => col.key === "time"
                  );
                  const timeIndex = visibleColumns.indexOf(timeCol);

                  const startIndex = visibleColumns.findIndex(
                    (col) => col.key === "activity"
                  );
                  const endIndex = visibleColumns.findIndex(
                    (col) => col.key === "location"
                  );
                  const remainingColSpan =
                    endIndex > startIndex ? endIndex - startIndex : 1;

                  return (
                    <TableRow key={idx}>
                      {/* Time Cell */}
                      <TableCell
                        align="center"
                        sx={{
                          position: "sticky",
                          left: 0,
                          zIndex: 1,
                          backgroundColor: "#fff", // or match the row background
                          minWidth: "120px",
                          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.1)",
                        }}
                      >
                        {entry.time}
                      </TableCell>

                      {/* Remaining Columns Merged */}
                      <TableCell colSpan={remainingColSpan}>
                        <Box
                          sx={{
                            textAlign: "center",
                            p: 3,
                            bgcolor: "#e1f5fe",
                            borderRadius: 2,
                          }}
                        >
                          <Celebration
                            sx={{ verticalAlign: "middle", mr: 1 }}
                          />
                          <Typography variant="body2" display="inline">
                            {entry.activity}
                          </Typography>
                          <Typography variant="body2">
                            <a
                              href={entry.location}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Location
                            </a>
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell align="center">
                        {" "}
                        <Typography variant="body2">
                          <a
                            href={entry.location}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Location
                          </a>
                        </Typography>
                      </TableCell>
                    </TableRow>
                  );
                }

                const isFinalLunch = /Final Lunch/i.test(entry.activity);
                const isLunchBreak = /Break for Lunch/i.test(entry.activity);

                const isCheckOut = /Check out/i.test(entry.activity);

                if (isFinalLunch || isLunchBreak || isCheckOut) {
                  const startIndex = visibleColumns.findIndex(
                    (col) => col.key === "activity"
                  );
                  const endIndex = visibleColumns.findIndex(
                    (col) => col.key === "location"
                  );
                  const remainingColSpan =
                    endIndex > startIndex ? endIndex - startIndex : 1;
                  return (
                    <TableRow key={idx}>
                      <TableCell
                        align="center"
                        sx={{
                          position: "sticky",
                          left: 0,
                          zIndex: 1,
                          backgroundColor: "#fff", // or match the row background
                          minWidth: "120px",
                          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.1)",
                        }}
                      >
                        {entry.time}
                      </TableCell>
                      <TableCell colSpan={remainingColSpan} sx={{}}>
                        <Box
                          sx={{
                            textAlign: "center",
                            p: 3,
                            borderRadius: 2,
                            backgroundColor:
                              isLunchBreak || isFinalLunch || isCheckOut
                                ? "#d0f0c0"
                                : "#ccef55",
                            "&:hover": {
                              backgroundColor:
                                isLunchBreak || isFinalLunch || isCheckOut
                                  ? "#b8e2ac"
                                  : "#aad4f5",
                            },
                            p: 3,
                          }}
                        >
                          {isFinalLunch || isLunchBreak ? (
                            <>
                              <LocalDining
                                sx={{ verticalAlign: "middle", mr: 1 }}
                              />
                            </>
                          ) : (
                            <>
                              <TaskAltIcon
                                sx={{ verticalAlign: "middle", mr: 1 }}
                              />
                            </>
                          )}

                          <Typography variant="body2" display="inline">
                            {entry.activity}
                          </Typography>
                          {entry.location ? (
                            <Typography variant="body2">
                              <a
                                href={entry.location}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View Location
                              </a>
                            </Typography>
                          ) : (
                            ""
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                }

                return (
                  <TableRow key={idx}>
                    {visibleColumns.map((col, colIdx) => {
                      const span = rowSpanMaps[col.key][idx];
                      if (span === undefined) return null;
                      const isFirstColumn = colIdx === 0;
                      const value = entry[col.key];

                      if (col.key === "instructor" && value) {
                        const instructors = Array.isArray(value)
                          ? value
                          : [value];

                        return (
                          <TableCell
                            key={col.key}
                            rowSpan={span}
                            align="center"
                          >
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              {/* Avatars row */}
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: 1,
                                  flexWrap: "wrap",
                                  justifyContent: "center",
                                }}
                              >
                                {instructors.map((inst, i) => (
                                  <Tooltip key={i} title="Click for more info">
                                    <Avatar
                                      src={inst.avatar}
                                      alt={inst.name}
                                      onClick={(e) =>
                                        handlePopoverOpen(e, inst)
                                      }
                                      sx={{
                                        cursor: "pointer",
                                        width: 40,
                                        height: 40,
                                      }}
                                    />
                                  </Tooltip>
                                ))}
                              </Box>

                              {/* Names row */}
                              <Typography
                                variant="body2"
                                align="center"
                                sx={{ whiteSpace: "pre-wrap" }}
                              >
                                {instructors
                                  .map((inst) => inst.name)
                                  .join(", ")}
                              </Typography>
                            </Box>
                          </TableCell>
                        );
                      }

                      if (col.key === "location" && value) {
                        return (
                          <TableCell
                            key={col.key}
                            rowSpan={span}
                            align="center"
                          >
                            <a
                              href={value}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {value}
                            </a>
                          </TableCell>
                        );
                      }

                      if (
                        ["readings", "assignments", "tools"].includes(
                          col.key
                        ) &&
                        value
                      ) {
                        if (Array.isArray(value)) {
                          return (
                            <TableCell
                              key={col.key}
                              rowSpan={span}
                              align="center"
                            >
                              <Box
                                component="ul"
                                sx={{
                                  listStyle: "disc",
                                  pl: 2,
                                  m: 0,
                                  textAlign: "left",
                                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                }}
                              >
                                {value.map((tool, i) => {
                                  const text =
                                    typeof tool === "object" ? tool.text : tool;
                                  const url =
                                    typeof tool === "object" ? tool.url : null;
                                  return (
                                    <li key={i} style={{ marginBottom: "4px" }}>
                                      {url ? (
                                        <a
                                          href={url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            wordBreak: "break-word",
                                            color: "#1a73e8",
                                          }}
                                        >
                                          {text}
                                        </a>
                                      ) : (
                                        text
                                      )}
                                    </li>
                                  );
                                })}
                              </Box>
                            </TableCell>
                          );
                        } else {
                          return (
                            <TableCell
                              key={col.key}
                              rowSpan={span}
                              align="center"
                            >
                              <Chip
                                label={value}
                                size="small"
                                variant="outlined"
                              />
                            </TableCell>
                          );
                        }
                      }

                      return (
                        <TableCell
                          key={col.key}
                          rowSpan={span}
                          align="center"
                          sx={{
                            position: isFirstColumn ? "sticky" : "static",
                            left: isFirstColumn ? 0 : "auto",
                            zIndex: isFirstColumn ? 1 : "auto",
                            backgroundColor: isFirstColumn ? "#fff" : "inherit",
                          }}
                        >
                          {value || "-"}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>

        <Popover
          open={isPopoverOpen}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              p: 2,
              display: "flex",
              alignItems: "center",
              gap: 2,
              maxWidth: { xs: "90vw", sm: 300 },
              flexWrap: "wrap",
            },
          }}
        >
          {popoverData && (
            <>
              <IconButton
                size="small"
                onClick={handlePopoverClose}
                sx={{ position: "absolute", top: 4, right: 4 }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
              <Avatar
                src={popoverData.avatar}
                alt={popoverData.name}
                sx={{ width: 56, height: 56 }}
              />
              <Box>
                <Typography variant="subtitle1" fontWeight={600}>
                  {popoverData.name}
                </Typography>
                <Typography variant="body2">
                  {popoverData.specialization}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {popoverData.email}
                  <IconButton
                    size="small"
                    onClick={() =>
                      navigator.clipboard.writeText(popoverData.email)
                    }
                  >
                    <ContentCopy fontSize="small" />
                  </IconButton>
                </Typography>
              </Box>
            </>
          )}
        </Popover>
      </Container>
    </Box>
  );
};

export default ScheduleSummer2025;
